import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from '..';
import { IGetProductPreviewResponse } from '../../api/product/iApiResponse';
import { EReduxState } from '../enum';
import { IReduxState } from '../interface';

const initialState: IReduxState<IGetProductPreviewResponse[]> = {
    status: EReduxState.initialState,
};

export const productPreviewSlice = createSlice({
    name: 'productPreview',
    initialState,
    reducers: {
        cleanProduct: state => {
            state.status = EReduxState.initialState;
            state.data = undefined;
        },
        setProductPreview: (state, action: PayloadAction<IGetProductPreviewResponse[]>) => {
            state.status = EReduxState.fulfilled;
            state.data = action.payload;
        },
    },
});

export const { cleanProduct, setProductPreview } = productPreviewSlice.actions;

export const selectProductPreview = (state: RootState) => state.productPreview;

export default productPreviewSlice.reducer;
